<template>
  <div class="left">
    <top-banner class="banner"></top-banner>
    <login-info class="login-info"></login-info>
    <func-union v-if="isLogin" class="func-union"></func-union>
    <safe-footer></safe-footer>
    <page-footer></page-footer>
  </div>
</template>

<script>
import TopBanner from '@components/officialWebStore/TopBanner.vue';
import PageFooter from '@components/officialWebStore/PageFooter.vue';
import { mapState } from 'vuex';
import login from '@mixins/officialWebStore/login';
import LoginInfo from '@components/officialWebStore/login/LoginInfo.vue';
import FuncUnion from '@components/officialWebStore/FuncUnion.vue';
import SafeFooter from '@components/officialWebStore/SafeFooter.vue';

export default {
  mixins: [login],
  computed: {
    ...mapState({
      letter: state => state.letter
    })
  },
  components: { TopBanner, PageFooter, LoginInfo, FuncUnion, SafeFooter }
};
</script>

<style scoped lang="scss">
@import '@assets/scss/officialWebStore/officialWebStore.scss';
.left {
  display: none;
}
@media screen and (orientation: landscape) {
  .left {
    position: relative;
    display: block;
    width: 364px;
    ::v-deep .footer {
      position: relative;
      display: flex;
      flex-direction: column;
      padding: 0 20px;
      margin-top: 30px;
      border-radius: 10px;
      background-color: #fff;
      box-shadow: 0px 10px 10px #e7e7e7;
    }
    ::v-deep .link-box {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    ::v-deep .copyright {
      line-height: 16px;
      font-size: 16px;
      color: #333333;
      padding: 24px 0;
    }
    ::v-deep .link {
      padding: 24px 0;
      width: 100%;
      border-bottom: 1px solid #dfdfdf;
      font-size: 16px;
      color: #333333;
      margin: 0;
      cursor: pointer;
      &:hover {
        color: $btnBg;
      }
    }
  }
}
</style>
